/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioTestResultStatus } from './InternalApiScenarioTestResultStatus';
import {
    InternalApiScenarioTestResultStatusFromJSON,
    InternalApiScenarioTestResultStatusFromJSONTyped,
    InternalApiScenarioTestResultStatusToJSON,
    InternalApiScenarioTestResultStatusToJSONTyped,
} from './InternalApiScenarioTestResultStatus';

/**
 * 
 * @export
 * @interface InternalApiScenarioTestResult
 */
export interface InternalApiScenarioTestResult {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioTestResult
     */
    testExecutionId: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioTestResult
     */
    testExecutionHandle?: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioTestResult
     */
    scenarioContentId: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioTestResult
     */
    scenarioVersionId?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioTestResult
     */
    scenarioContentHandle: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioTestResult
     */
    startedTime?: Date;
    /**
     * Test execution duration in milliseconds
     * @type {number}
     * @memberof InternalApiScenarioTestResult
     */
    executionTotalDuration?: number;
    /**
     * 
     * @type {InternalApiScenarioTestResultStatus}
     * @memberof InternalApiScenarioTestResult
     */
    status: InternalApiScenarioTestResultStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioTestResult
     */
    statusMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioTestResult
     */
    note?: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioTestResult
     */
    testDataTimeFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioTestResult
     */
    testDataTimeTo: Date;
}



/**
 * Check if a given object implements the InternalApiScenarioTestResult interface.
 */
export function instanceOfInternalApiScenarioTestResult(value: object): value is InternalApiScenarioTestResult {
    if (!('testExecutionId' in value) || value['testExecutionId'] === undefined) return false;
    if (!('scenarioContentId' in value) || value['scenarioContentId'] === undefined) return false;
    if (!('scenarioContentHandle' in value) || value['scenarioContentHandle'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('testDataTimeFrom' in value) || value['testDataTimeFrom'] === undefined) return false;
    if (!('testDataTimeTo' in value) || value['testDataTimeTo'] === undefined) return false;
    return true;
}

export function InternalApiScenarioTestResultFromJSON(json: any): InternalApiScenarioTestResult {
    return InternalApiScenarioTestResultFromJSONTyped(json, false);
}

export function InternalApiScenarioTestResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioTestResult {
    if (json == null) {
        return json;
    }
    return {
        
        'testExecutionId': json['testExecutionId'],
        'testExecutionHandle': json['testExecutionHandle'] == null ? undefined : json['testExecutionHandle'],
        'scenarioContentId': json['scenarioContentId'],
        'scenarioVersionId': json['scenarioVersionId'] == null ? undefined : json['scenarioVersionId'],
        'scenarioContentHandle': json['scenarioContentHandle'],
        'startedTime': json['startedTime'] == null ? undefined : (new Date(json['startedTime'])),
        'executionTotalDuration': json['executionTotalDuration'] == null ? undefined : json['executionTotalDuration'],
        'status': InternalApiScenarioTestResultStatusFromJSON(json['status']),
        'statusMessage': json['statusMessage'] == null ? undefined : json['statusMessage'],
        'note': json['note'] == null ? undefined : json['note'],
        'testDataTimeFrom': (new Date(json['testDataTimeFrom'])),
        'testDataTimeTo': (new Date(json['testDataTimeTo'])),
    };
}

export function InternalApiScenarioTestResultToJSON(json: any): InternalApiScenarioTestResult {
    return InternalApiScenarioTestResultToJSONTyped(json, false);
}

export function InternalApiScenarioTestResultToJSONTyped(value?: InternalApiScenarioTestResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'testExecutionId': value['testExecutionId'],
        'testExecutionHandle': value['testExecutionHandle'],
        'scenarioContentId': value['scenarioContentId'],
        'scenarioVersionId': value['scenarioVersionId'],
        'scenarioContentHandle': value['scenarioContentHandle'],
        'startedTime': value['startedTime'] == null ? value['startedTime'] : value['startedTime'].toISOString(),
        'executionTotalDuration': value['executionTotalDuration'],
        'status': InternalApiScenarioTestResultStatusToJSON(value['status']),
        'statusMessage': value['statusMessage'],
        'note': value['note'],
        'testDataTimeFrom': value['testDataTimeFrom'].toISOString(),
        'testDataTimeTo': value['testDataTimeTo'].toISOString(),
    };
}

